var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['overlay', ("overlay-" + _vm.position)],attrs:{"id":"spinner-overlay"}},[_c('div',{staticClass:"spinner-container"},[_c('b-spinner',{staticClass:"loading-spinner",attrs:{"variant":"primary-dark"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }